<style scoped>
.el-col-5{
  width: 30%;
}
  
</style>
<template>
  <div class="content">
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="8"
          ><div class="search-area-div">单位名称：</div>
          <el-input v-model="page.typeintroduction" class="ipt-sty w70f" placeholder="请输入单位名称"></el-input
        ></el-col>
        <el-col :span="8">
          <el-button size="medium" type="info" @click="getData(true)">搜索</el-button>
          <el-button size="medium" type="danger" @click="empty">清空</el-button>
        </el-col>
      </el-row>
    </div>
    <div class="button-area">
      <el-button icon="el-icon-plus" size="medium" type="info" @click="add(1, '')">新增单位</el-button>
      <el-button size="medium" type="danger" @click="getDeleteData(1, '')">批量删除</el-button>
      <!-- <el-button plain size="medium">历史数据</el-button> -->
    </div>
    <div class=" back-color-fff" style="padding: 16px;">
      <el-table :data="tableData" @selection-change="handleSelectionChange" border style="width: 100%;">
        <el-table-column type="selection" width="60" header-align="center" align="center"></el-table-column>
        <el-table-column label="序号" width="60" header-align="center" align="center">
          <template slot-scope="scope">
            <!-- {{ scope.$index + 1 }} -->
            {{(page.pageIndex - 1) * page.pageSize + scope.$index + 1}}
          </template>
        </el-table-column>
        <el-table-column prop="typeintroduction" label="单位名称" header-align="center" align="center"></el-table-column>
        <el-table-column prop="datavalue" label="精度" header-align="center" align="center"></el-table-column> 
        <el-table-column prop="dataintroduction" label="单位说明" header-align="center" align="center"> 
        </el-table-column> 
        <el-table-column prop="updateUserName" label="修改人" header-align="center" align="center"></el-table-column> 
        <el-table-column prop="updateTime" label="更新时间" sortable header-align="center" align="center">
          <template slot-scope="scope">{{ scope.row.updateTime | getTimeDate }}</template>
        </el-table-column>
        <el-table-column label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <a class="txt-color" @click="add(2, scope.row)">编辑 | </a>
            <a class="txt-color-red" @click="getDeleteData(2, scope.row.guid)">删除</a>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      class="pt pb back-color-fff"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 100, 200]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination>
    <el-dialog :title="textTitle" :visible.sync="dialogFormVisible" width="550px">
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        :label-position="right"
        class="demo-ruleForm"
      >
        <el-form-item label="单位名称:" prop="typeintroduction">
          <el-input v-model="ruleForm.typeintroduction" autocomplete="off" class="w100f" placeholder="请输入单位名称"></el-input>
        </el-form-item> 
        <el-form-item label="精度:" prop="dataintroduction">
          <el-input v-model="ruleForm.dataintroduction" autocomplete="off" class="w100f" placeholder="请输入数据值说明"></el-input>
        </el-form-item>
        <el-form-item label="单位说明:" prop="dataseqno">
          <el-input v-model="ruleForm.dataseqno" autocomplete="off" class="w100f" placeholder="请输入单位说明"></el-input>
        </el-form-item> 
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button plain size="medium" @click="dialogFormVisible = false">取消</el-button>
        <el-button size="medium" type="info" v-if="textTitle == '新增单位'" @click="submitForm('ruleForm')"
          >确定</el-button
        >
        <el-button size="medium" type="info" v-else @click="upDateForm('ruleForm')">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      input: '',
      textTitle: '',
      right: '',
      dialogVisible: false,
      dialogFormVisible: false,
      formLabelWidth: '120px',
      ruleForm: {
        guid: '',
        typeintroduction: '',
        datavalue: '', 
        dataintroduction: '',
        dataseqno: '',
        // updateUserName:'',
        // updateTime:'',
        state:'Y',
      },
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0, 
        typeintroduction: '',
        datavalue: '', 
      },
      dto:{
        pageIndex: 1,
        pageSize: -1,
        totalPage: 0,
        totalRows: 0, 
        tenantGuid: '', 
        code: '',
        name:'',
        parameterValue:'',
      },
      tableData: [],
      rules: {
          typeintroduction: [
            { required: true, message: '请输入类型值说明', trigger: 'blur' }, 
          ],
          datavalue: [
            { required: true, message: '请输入数据值', trigger: 'blur' }, 
          ],
          dataintroduction: [
            { required: true, message: '请输入数据值说明', trigger: 'blur' }, 
          ],
          dataseqno: [
            { required: true, message: '请输入数据值序号', trigger: 'blur' }, 
          ], 
          // repositoryType: [
          //   { required: true, message: '请输入算法类型', trigger: 'change' }
          // ],
          // repositoryUse: [
          //   { required: true, message: '请输入算法用途', trigger: 'change' }
          // ],
      },
      multipleSelection: [],
      repositoryTypeList:[],
    };
  },
  created() {
    // 列表
    this.getData(false);
    // this.getrepositoryTypeList();
  },
  methods: {
    empty() {
      let self = this;
      self.page = {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        typeintroduction: '',
        datavalue: '', 
      };
      self.getData(true);
    },
    getData(flg) {
      let self = this;
      if (flg) {
        self.page.pageIndex = 1;
      }
      // self.page.tenantGuid = self.$store.getters.getTenantGuid;
      self.api.postJson(`/${serverConfig.msAiAlgorithmService}/sys-conf/data-dic/get`, self.page).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records;
          // self.tableData.forEach(function(item) {
          //   item.bizState = item.bizState == 'Y' ? '有效' : '停用';
          // });
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getrepositoryTypeList() {
      let self = this;
      self.dto.tenantGuid = self.$store.getters.getTenantGuid;
      self.dto.code = 'SFLX';
      self.api.postJson(`/${serverConfig.msAiAlgorithmService}/sysparameter/data/get`, self.dto).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.repositoryTypeList = res.data.data.records; 
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    handleSelectionChange(val) {
      let self = this;
      self.multipleSelection = [];
      val.forEach(function(item) {
        //item 就是当日按循环到的对象
        self.multipleSelection.push(item.guid);
      });
    },

    getDeleteData(flg, guid) {
      let self = this;
      if (flg == 1) {
        if (self.multipleSelection.length == 0) {
          self.$message.error('请勾选数据！');
          return;
        }
      } else {
        self.multipleSelection = [];
        self.multipleSelection.push(guid);
      }
      this.$confirm('是否确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          self.api
            .postJson(`/${serverConfig.msAiAlgorithmService}/sys-conf/data-dic/delete`, self.multipleSelection)
            .then(res => {
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                self.multipleSelection = [];
                self.$message.success('删除数据字典成功');
                self.getData(true);
              } else {
                self.$message.error(res.data.msg);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
    add(flg, row) {
      let self = this;
      if (flg == 1) {
        self.textTitle = '新增单位';
        self.ruleForm.typeintroduction = '';
        self.ruleForm.datavalue = '';
        self.ruleForm.dataintroduction = '',
        self.ruleForm.dataseqno = '',
        self.ruleForm.state = 'Y';
      } else {
        self.textTitle = '编辑单位';
        self.ruleForm.guid = row.guid;
        self.ruleForm.typeintroduction = row.typeintroduction;
        self.ruleForm.datavalue = row.datavalue;
        self.ruleForm.dataintroduction = row.dataintroduction;
        self.ruleForm.dataseqno = row.dataseqno;
        self.ruleForm.state = row.state;
      }
      this.dialogFormVisible = true;
    },
    submitForm(formName) {
      let self = this;
      self.$refs[formName].validate(valid => {
        if (valid) {
          let promise = { 
            typeintroduction: self.ruleForm.typeintroduction,
            datavalue: self.ruleForm.datavalue,
            dataintroduction: self.ruleForm.dataintroduction,
            // dataseqno: parseInt(self.ruleForm.dataseqno),
            dataseqno: self.ruleForm.dataseqno,
            state: self.ruleForm.state,
          };
          self.api.postJson(`/${serverConfig.msAiAlgorithmService}/sys-conf/data-dic/add`, promise).then(res => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.dialogFormVisible = false;
              self.$message.success('添加数据字典成功');
              self.getData(true);
            } else {
              self.$message.error(res.data.msg);
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    upDateForm(formName) {
      let self = this;
      self.$refs[formName].validate(valid => {
        if (valid) {
          let promise = {
            guid: self.ruleForm.guid,
            typeintroduction: self.ruleForm.typeintroduction,
            datavalue: self.ruleForm.datavalue,
            dataintroduction: self.ruleForm.dataintroduction,
            // dataseqno: parseInt(self.ruleForm.dataseqno),
            dataseqno: self.ruleForm.dataseqno,
            state: self.ruleForm.state,
          };
          self.api.put(`/${serverConfig.msAiAlgorithmService}/sys-conf/data-dic/update`, promise).then(res => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              self.dialogFormVisible = false;
              self.$message.success('编辑数据字典成功');
              self.getData(true);
            } else {
              self.$message.error(res.data.msg);
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getData();
    },
  },
};
</script>
